import { initMediaEntrance } from "./utils/media-entrance";
import { initPageEntrance } from "./utils/page-entrance";
import { initMobileMenu } from "./components/mobile-menu";
import { initServicesSlider } from "./components/services-slider";
import { initSelectFields } from "./components/form/select-fields";
import { initFileFields } from "./components/form/file-fields";
import { initContactForm } from "./components/form/contact-form";

initMediaEntrance();
initPageEntrance();
initMobileMenu();
initSelectFields();
initFileFields();
initContactForm();

if (!document.body.classList.contains('elementor-editor-active')) {
    initServicesSlider();
}